import { FC } from 'react'
import { useSelectTankStore } from '../../store/selectTank/useSelectTankStore'
import { useActiveRelationStore } from '../../store/activeRelation/useActiveRelationStore'
import { useTankStore } from '../../store/tank/useTankStore'
import { useBatchStore } from '../../store/batch/useBatchStore'
import { SubmitTankType } from '../../types/apiResponse/tankTypes'
import TankChip from './TankChip'

export type TankChipContainerProps = {
  title: string
  batchId: string
}

export const TankChipContainer: FC<TankChipContainerProps> = ({ title, batchId }) => {
  const { attach, detach, contains } = useSelectTankStore()
  const activeRelations = useActiveRelationStore((state) => state.activeRelations)
  const tanks = useTankStore((state) => state.tanks)
  const batchName = useBatchStore((state) => state.batches[batchId].batchName)
  const tankChips =
    activeRelations[batchId] === undefined
      ? []
      : activeRelations[batchId].map((activeRelation, index) => {
          const tankId = activeRelation.tankId
          const tankType: SubmitTankType = {
            tankId: tankId,
            tankName: tanks[tankId].tankName,
            batchId: batchId,
            batchName: batchName,
          }

          const onTankChipClick = (tankId: string) => {
            if (contains(tankId)) detach(tankId)
            else attach(tankType)
          }
          return (
            <TankChip
              key={index}
              submitTank={tankType}
              isActivated={contains(tankId)}
              onTankChipClick={onTankChipClick}
            />
          )
        })

  return (
    <>
      {tankChips.length === 0 ? null : (
        <div
          data-testid={`tank-chip-container-${batchId}`}
          data-batch-id={batchId}
          data-batch-name={batchName}
          data-tank-count={tankChips.length}
        >
          <p
            className="text-tdplindigo text-[1rem] my-2"
            data-testid={`tank-container-title-${batchId}`}
          >
            {title}
          </p>
          <div
            className="flex flex-row flex-wrap my-2 mx-1"
            data-testid={`tank-chips-list-${batchId}`}
            role="group"
            aria-label={`Tank selection for ${title}`}
          >
            {tankChips}
          </div>
        </div>
      )}
    </>
  )
}
